export const generateBreezeEmailTemplate = (
  platformUrl = "https://app.breeze-security.com"
) => {
  // Remove trailing slash if present
  const baseUrl = platformUrl.replace(/\/$/, "");

  return `<head>
    <style>
        .email-table { font-family: sans-serif; color: black; font-size: 14px; border-collapse: collapse; width: 100%; margin: 5px 0;}
        p {line-height: 1.5;}
    </style>
</head>
<table class="email-table" style="width: 100%;">
    <tr>
        <td align="center">
            <div align="left" style="width: 600px; border: 1px solid #e3e3e3;">
                <header style="padding: 3px; cursor: pointer;">
                    <a href="${baseUrl}" target="_blank">
                        <div style="background-color: #0343B7; padding: 20px; border-radius: 4px 4px 0 0;">
                            <img src="https://breeze-security-public.s3.eu-west-1.amazonaws.com/images/full_logo_white.png" width="100px"/>
                        </div>
                    </a>
                </header>
                <section style="padding: 0 20px 20px 20px;">
                    <h3>Your Email Title Here</h3>
                    <p>Write your email content here...</p>
                    <p>You can add multiple paragraphs, lists, and other HTML elements.</p>
                </section>
            </div>
            <footer style="margin: auto; text-align: center; margin: 15px 0;">
                <a href="${baseUrl}/settings?tab=personal-notifications" target="_blank" style="font-size: 12px; color: #0343B7;">Manage Your Notification Preferences</a>
            </footer>
        </td>
    </tr>
</table>`;
};

// Hook to get email template with dynamic URL
export const useEmailTemplate = () => {
  // This will be replaced with actual API call in the component
  return generateBreezeEmailTemplate;
};
